var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0E0FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 17L17 31",
    stroke: "#4C0A82",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 19.5C22.75 21.2949 21.2949 22.75 19.5 22.75C17.7051 22.75 16.25 21.2949 16.25 19.5C16.25 17.7051 17.7051 16.25 19.5 16.25C21.2949 16.25 22.75 17.7051 22.75 19.5Z",
    fill: "#4C0A82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 28.5C31.75 30.2949 30.2949 31.75 28.5 31.75C26.7051 31.75 25.25 30.2949 25.25 28.5C25.25 26.7051 26.7051 25.25 28.5 25.25C30.2949 25.25 31.75 26.7051 31.75 28.5Z",
    fill: "#4C0A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentNext);
export default __webpack_public_path__ + "static/media/payment_next.3436c3a57842e52ed34cf7e98db4f7ce.svg";
export { ForwardRef as ReactComponent };